import { AbilityBuilder } from "@casl/ability";

import { Ability } from "../../models/permissions";
import { AbilityService } from "./ability";

const abilityBuilder = new AbilityBuilder<Ability>();

export default new AbilityService(abilityBuilder);
